'use client'
import React from 'react'
import MainContainer from '../../../containers/MainContainer'
import MainUI from './MainUI'

const Main = props => {
  return (
   <MainContainer {...props}>
    <MainUI {...props} />
   </MainContainer>
    
  )
}

export default Main
